module.exports = __webpack_public_path__ + "media/images/icon_insurance-c52a955b62527efa6b66125d697c75fa.png";